import React from 'react';
import { StyledInput, StyledMobileInputContainer } from './style';
import Icon from '../Icon';
import { changeNumber } from '../../../Utils/common.util';
import { StyledError } from '../../../Theme/CommonStyled';

type MobileInputType = {
  value: string;
  error?: boolean;
  onChange: (value: string) => void;
  errorMessage?: string;
};
const MobileInput: React.FC<MobileInputType> = ({
  value,
  error,
  onChange,
  errorMessage
}) => {
  return (
    <>
      <StyledMobileInputContainer value={value}>
        <Icon
          name="mobile_device"
          fontSize={13}
          mr={6}
          mt={3}
          color={
            error ? 'danger' : !value.length ? 'minorText' : 'secondaryGreen'
          }
        />
        <StyledInput
          className="InputNum"
          value={value}
          autoFocus
          placeholder={'09123456789'}
          autoComplete={'tel'}
          onChange={(e) => onChange(changeNumber(e.target.value))}
          maxLength={11}
          type="tel"
        />
      </StyledMobileInputContainer>
      {<StyledError>{error && errorMessage}</StyledError>}
    </>
  );
};

export default MobileInput;
